import React, { useState } from 'react';
import { Typography } from '@pwskills/rachnaui';
import {
  LeadCaptureEnquiryType,
  LeadCaptureType,
  LeadType,
  ModalType,
} from '@/interfaces/leadCapture.enum';
import useUserDetails from '@/store/userDetails';
// import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { useRouter } from 'next/router';
import { usePWAuthWebSDK } from '@/hooks/usePWAuthWebSDK';
import { useUTMParameters } from '@pwskills/rachnaui/hooks';
import { AuthEnums } from '@/GlobalEnums/enums';
import Download from '../../Icons/courseDescription/Download';
import OnboardingLeadForm from '../../OnboardingLeadForm';
import { GAevent } from '../../../../utils/firebase.utils';

type Props = {
  curriculumPdf?: string;
  courseName?: string;
  courseId?: string;
  categoryName?: string;
  categoryId?: string;
  courseType?: string;
};

// const OTP = '1234';

const DownloadCurriculum = (props: Props) => {
  // const { courseDetails } = useContext(CourseDescriptionContext);
  const { userIsLoggedIn: isLoggedIn, userDetails: user } = useUserDetails();
  const { curriculumPdf, courseName, courseId, categoryId, categoryName, courseType } = props;
  const [openModal, setOpenModal] = useState(false);
  const router = useRouter();
  const utmQuery = useUTMParameters();

  const { initApp } = usePWAuthWebSDK({
    sdkProps: {
      themeFor: 'skills',
      onGoogleSignIn: () => {
        // your logic
      },
      googleClientId: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || '',
      cameFrom: AuthEnums.BLOG,
      ctaName: AuthEnums.LOGIN,
      formLocation: 'course_description',
      course_batch_name: courseName,
      course_batch_category: categoryName,
      course_batch_id: courseId,
      course_batch_cohort_id: categoryId,
    },
    onAuthSuccessCallBack: () => {
      setOpenModal(true);
    },
  });

  const handleGAEvent = (source: string) => {
    const GAEventData = {
      source,
      ...utmQuery,
    };
    GAevent('sk_login_page_visit', GAEventData);
  };

  const sendGAEvent = (clickText: string) => {
    const GAEventData = {
      user_id: user?._id,
      user_type: isLoggedIn ? 'logged_in' : 'logged_out',
      user_category: user?.userType || '',
      click_text: clickText,
      page_name: 'course_description_page',
      category_id: categoryId || '',
      category_name: categoryName || '',
      course_id: courseId || '',
      course_name: courseName || '',
      course_type: courseType || '',
      utm_source: utmQuery?.utm_source || '',
      utm_medium: utmQuery?.utm_medium || '',
      utm_campaign: utmQuery?.utm_campaign || '',
      page_ref: router?.query?.from || '',
    };
    GAevent('sk_course_descrip_action', GAEventData);
  };

  return (
    <div>
      <button
        type="button"
        className="hover:transition-transform !duration-300 !ease-in-out hover:scale-110 flex gap-4 justify-center items-center  bg-white rounded-[240px] py-[7px] regular:!py-4 regular:px-5 px-10 cursor-pointer"
        onClick={() => {
          sendGAEvent('download curriculum');
          if (isLoggedIn) {
            setOpenModal(true);
          } else {
            initApp();
            handleGAEvent('Download Curriculum');
          }
        }}
      >
        <Typography
          variant="semi-bold"
          component="body-regular"
          className="text-orange-500 !text-[16px]"
        >
          Download Curriculum
        </Typography>
        <div className="w-9 h-9 bg-orange-500 rounded-[50%] flex justify-center items-center">
          <Download />
        </div>
      </button>

      {openModal && (
        <OnboardingLeadForm
          type={LeadType.DOWNLOAD_CURRICULUM}
          modalType={ModalType.LEAD_FORM}
          modalOpen={openModal}
          setModalOpen={setOpenModal}
          curriculumPdf={curriculumPdf}
          enquiryTypeNPF="Download Curriculum"
          enquiryType={LeadCaptureEnquiryType.DOWNLOAD_CURRICULUM}
          pageName="course_description"
          leadCaptureType={LeadCaptureType.MODAL}
          buttonText=""
          msgLineOne="Your file is now started downloading"
        />
      )}
    </div>
  );
};

export default DownloadCurriculum;
